import { useContext } from "react";
import { SideNavContext } from "./SideNavContext";

/**
 * Custom hook for accessing the SideNav context.
 * @returns The SideNav context with links, activeIds, and utility functions
 * @throws Error if used outside of a SideNav component
 */
export const useSideNav = () => {
  const context = useContext(SideNavContext);

  if (context == null) {
    throw new Error("useSideNav must be wrapped in <SideNav />");
  }

  return context;
};
